var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppActivityinsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#C7F760"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48H40",
    stroke: "#1E53E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 40V19.2C16 18.3513 16.3371 17.5374 16.9373 16.9373C17.5374 16.3371 18.3513 16 19.2 16H44.8C45.6487 16 46.4626 16.3371 47.0627 16.9373C47.6629 17.5374 48 18.3513 48 19.2V40C48 40.8487 47.6629 41.6626 47.0627 42.2627C46.4626 42.8629 45.6487 43.2 44.8 43.2H19.2C18.3513 43.2 17.5374 42.8629 16.9373 42.2627C16.3371 41.6626 16 40.8487 16 40Z",
    stroke: "#1E53E8",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0039 29.5111H27.5595L30.2261 36.6222L33.7817 22.4L36.4484 29.5111H40.0039",
    stroke: "#1E53E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppActivityinsight);
export default __webpack_public_path__ + "static/media/AppActivityinsight.dc76d72b8d5ebeb16a27cd096d7d057d.svg";
export { ForwardRef as ReactComponent };